import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import Popup from '../components/Popup';
import SystemCard from '../components/SystemCard';
import DenyAccessPage from '../components/DenyAccessPage';
import { getWisdomSystems } from 'constants/constants';
import ModernBackground from 'components/ui/ModernBackground';
import { fetchTaskNotifications, markTaskNotificationsAsRead } from 'services/tms';
import WisdomNavbar from 'components/navbars/WisdomNabvar';
import { useTheme } from 'context/ThemeContext';

const Wisdom = () => {
    const { userInfo, logout } = useAuth();
    const { language } = useLanguage();
    const [notAvailable, setNotAvailable] = useState(false);
    const { darkMode } = useTheme();
    const [popupMessage, setPopupMessage] = useState();
    const [popupType, setPopupType] = useState(null);

    // Wabys Systems Data
    const wabysSystems = getWisdomSystems(language, userInfo?.organization_id, userInfo);

    // open pop up notification function for both unavailable models or task notifications
    const openPopup = () => {
        setPopupType("default");
        setPopupMessage(language ? "This system will be available soon" : "هذا النظام سيتم إطلاقه قريباً");
        setNotAvailable(true);
    };
    // close pop up notification function for both unavailable models or task notifications/*  */
    const closePopup = async () => {
        setNotAvailable(false);
        if (popupType === "tasks") {
            await markTaskNotificationsAsRead("wisdom", userInfo?.token);
        }
        setPopupType(null);
    };

    // fetch user's task notifications
    useEffect(() => {
        const loadingTaskNotification = async () => {
            try {
                const response = await fetchTaskNotifications("wisdom", userInfo?.token);

                const total =
                    response.notificationCount +
                    response.dueTodayCount +
                    response.reviewerNotificationCount +
                    response.managerNotificationCount;

                if (total > 0) {
                    setPopupType("tasks");
                    setNotAvailable(true);
                    setPopupMessage(`
                        لديك ${response.notificationCount} مهام جديدة
                        
                        لديك ${response.dueTodayCount} مهام تنتهي اليوم
                        
                        لديك ${response.reviewerNotificationCount} مهام كمراجع
                        
                        لديك ${response.managerNotificationCount} مهام كمدير
                    `);
                }
            } catch (error) {
                if (error?.status === 403) logout();
            }
        };

        if (userInfo?.token) {
            loadingTaskNotification();
        }
    }, [userInfo, logout]);

    if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
    if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
    if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;
    // if (!userInfo?.user_permissions.some(per => per.page.name === "Wisdom Main Page")) return <DenyAccessPage homePage='/' />;

    return (
        <div className={`min-h-screen w-full font-[Cairo,sans-serif] transition-colors duration-500 ${darkMode ? 'bg-watomsBlue text-white' : 'bg-gradient-to-br from-blue-50 via-white to-purple-100 text-gray-900'} relative overflow-hidden`}>
            <ModernBackground />
            <WisdomNavbar searchStatus={false} profilePage={true} systemInfo={true} logoutStatus={true} />

            {/* Main Content */}
            <div className="relative z-10 px-6 pb-12">
                {/* Wabys Systems Sub Header */}
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-watomsBlue dark:text-watomsLightBlue mb-2">
                        {language ? "Wabys Systems" : "أنظمة وابيز"}
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-darkTextSecondary">
                        {language ? "Access all integrated systems" : "الوصول لجميع الأنظمة المتكاملة"}
                    </p>
                </div>

                {/* Wabys Systems Grid - Smaller Cards */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-10 max-w-7xl mx-auto">
                    {wabysSystems
                        .slice()
                        .sort((a, b) => {
                            if (a.available === b.available) return 0;
                            return a.available ? -1 : 1;
                        }).map(system => (
                            <SystemCard
                                key={system.id}
                                openPopup={() => openPopup()}
                                available={system.available}
                                path={system.path}
                                color={system.color}
                                iconType="awesome"
                                icon={system.icon}
                                title={system.title}
                                subtitle={system.subtitle}
                            />
                        ))}
                </div>
            </div>

            <Popup
                isOpen={notAvailable}
                onClose={closePopup}
                // message={language ? "This system will be available soon" : "هذا النظام سيتم إطلاقه قريباً"}
                message={popupMessage}
                button={language ? "OK" : "حسناً"}
                form={false}
            />
        </div>
    );
};

export default Wisdom; 